class HumanSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }

    let humanFlag = true;

    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          if(humanFlag === true) {
            var humanSwiper = new Swiper("." + this.el, {
              slidesPerView: 1.2,
              speed: 500,
              navigation: {
                nextEl: ".humanSwiper-button-next",
                prevEl: ".humanSwiper-button-prev",
              },
              breakpoints: {
                // スライドの表示枚数：500px以上の場合
                767: {
                  slidesPerView: 3,
                }
              },
              pagination: {
                el: '.humanSwiper-pagination',
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                  return (
                    '<span class="border js-humanSwiper-border"><span></span></span>'
                  );
                },
                formatFractionCurrent: function (number) {
                  let num = number % 3 === 0 ? '3' : String(number % 3); // 文字列に統一
                  return '0' + num; // 01, 02, 03 のように2桁表記
                },
              },
              on: {
                init: function () {
                  setTimeout(() => {
                    const pagiNation = document.querySelector('.humanSwiper-pagination');
                    pagiNation.classList.add('is-active');
                  }, 100);
                },
                slideChangeTransitionStart: function () {
                  const border = document.querySelector('.js-humanSwiper-border span');
                  if (border) {
                    border.style.transitionTimingFunction = 'ease';
                    border.style.transitionDuration = '500ms';
                    border.style.transform = 'scaleX(0)';
                  }
                },
                slideChangeTransitionEnd: function () {
                  const border = document.querySelector('.js-humanSwiper-border span');
                  if (border) {
                    border.style.transitionTimingFunction = 'linear';
                    border.style.transitionDuration = '3500ms';
                    border.style.transform = 'scaleX(1)';
                  }
                },
              }
            });
            
            // スマホ以外なら autoplay スタート
            if (window.innerWidth >= 768) {
              humanSwiper.params.autoplay = { delay: 4000, disableOnInteraction: false };
              humanSwiper.autoplay.start();
            }
            humanFlag = false;
          }
        }
      });
    }, options);

    let swiperEl = document.querySelectorAll("." + this.el);

    swiperEl.forEach((e)=>{
      observerEnter.observe(e);
    });
  }
}